import register from 'ShopUiBundle/modules/app/registry';
import './style.scss';

// tslint:disable-next-line
register('bike-detail-cart-button', () => import(/* webpackMode: "lazy" */'./bike-detail-cart-button'));
